import React from 'react';
import { GlobalStyles } from './styles/GlobalStyles';
import Content from './Content';
import Header from './Header';
import styled from 'styled-components/macro';

const AppContainer = styled.div`
  max-width: 100vw;
  min-width: 580px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const AppItems = styled.div`
  width: 100%;
  max-width: 1440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 20px;
  padding-left: 20px;
`;

const App = () => (
  <>
    <GlobalStyles />
    <AppContainer>
      <AppItems>
        <Header />
        <Content />
      </AppItems>
    </AppContainer>
  </>
);

export default App;
